import { STATES } from "@/constants/states";
import { SUPPORT_EMAIL, SUPPORT_NUMBER } from "@/constants/aptihealth";

type FormElementConfig = {
  classNames?: string;
  displayName?: string;
  label?: string;
  options?: { display: string; value: string }[];
  placeholder?: string;
  type?: string;
};

type FormSchemaElement = {
  elementConfig: FormElementConfig;
  elementType: "input" | "select";
  name: string;
  onClick?: boolean;
  onclick?: (event: unknown, formikProps?: unknown) => void; // set via mutation in TeenChildSignup.js
};

export const BASIC_CONTACT_INFO_SCHEMA: FormSchemaElement[] = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
];

export const CHILD_ADDRESS_AUTOFILL: FormSchemaElement[] = [
  {
    elementConfig: {
      classNames: "font-gray",
      displayName: "Check this box if your child's address is the same as yours",
      type: "checkbox",
    },
    elementType: "input",
    name: "child_address_autofill",
    onClick: true,
  },
];

export const DEFAULT_CHILD_PRACTICE_AUTOFILL: FormSchemaElement[] = [
  {
    elementConfig: {
      classNames: "font-gray",
      displayName: "Child has a different Primary Care Physician than above",
      type: "checkbox",
    },
    elementType: "input",
    name: "default_child_practice_autofill",
    onClick: true,
  },
];

export const CHILD_SMS_CONSENT: FormSchemaElement[] = [
  {
    elementConfig: {
      classNames: "fs-14 font-gray",
      displayName: `I consent by electronic signature to receive calls, text messages (including SMS and MMS messages), and other electronic messages (including those made using an automatic telephone dialing system or an artificial or prerecorded voice) from aptihealth, healthcare providers with whom I am matched by aptihealth, or any of their agents or representatives at the phone number I have provided even if that number is registered on a corporate, state, or national do not call registry. I understand that my consent to such calls and messages is not required to use aptihealth’s services and that I may contact aptihealth at ${SUPPORT_EMAIL} or ${SUPPORT_NUMBER} about its services at any time. I also understand that I may revoke my consent at any time.`,
      type: "checkbox",
    },
    elementType: "input",
    name: "child_sms_consent",
    onClick: true,
  },
];

export const BASIC_ADDRESS_SCHEMA: FormSchemaElement[] = [
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
];

export const BASIC_EMERGENCY_CONTACT_SCHEMA: FormSchemaElement[] = [
  {
    elementConfig: {
      label: "Emergency contact person",
      placeholder: "Emergency contact person",
      type: "text",
    },
    elementType: "input",
    name: "emergency_name",
  },
  {
    elementConfig: {
      label: "Emergency contact number",
      placeholder: "Emergency contact number",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_no",
  },
];
